$(document).ready(function(){
  var dcs_popup_title = "You are leaving StevitaNaturals";
  var dcs_popup_content = 'You are about to be redirected to cookingwithstevia.com <br> <p style="color: #00B9D9 !important; margin: 14px 0 0 !important;">Thanks for visiting. Bookmark StevitaNaturals and come back soon.</p>';
  var dcs_confirm_text = "CONFIRM";
  var dcs_stay_text = "STAY";
  $('nav.header__inline-menu ul').children('li').eq(1).find('a').click(function(event){
    event.preventDefault();
    var curr_link_url = $(this).attr("href");
    swal({
      title: dcs_popup_title, 
      html: dcs_popup_content, 
      confirmButtonText: dcs_confirm_text,
      cancelButtonText: dcs_stay_text,
      showCancelButton: true,
    })
    .then((result) => {
      if (result.value) {
        window.location = curr_link_url;
      }
    });
  });

  $('ul.footer-block__details-content').children('li').eq(2).find('a').click(function(event){
    event.preventDefault();
    var curr_link_url = $(this).attr("href");
    swal({
      title: dcs_popup_title, 
      html: dcs_popup_content, 
      confirmButtonText: dcs_confirm_text,
      cancelButtonText: dcs_stay_text,
      showCancelButton: true,
    })
    .then((result) => {
      if (result.value) {
        window.location = curr_link_url;
      }
    });
  });
});